import { render } from "./ExternalAPI.vue?vue&type=template&id=15e16450"
import script from "./ExternalAPI.vue?vue&type=script&lang=js"
export * from "./ExternalAPI.vue?vue&type=script&lang=js"

import "./ExternalAPI.vue?vue&type=style&index=0&id=15e16450&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__